import { render } from "./AppCards.vue?vue&type=template&id=feadb508&scoped=true"
import script from "./AppCards.vue?vue&type=script&lang=js"
export * from "./AppCards.vue?vue&type=script&lang=js"

import "./AppCards.vue?vue&type=style&index=0&id=feadb508&scoped=true&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feadb508"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QImg});qInstall(script, 'directives', {Scroll});
